import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        role: '',
        content: '',
        rating: 5,
        is_active: true,
    });
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState(null);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const response = await axios.get('http://localhost:8000/api/admin/testimonials', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setTestimonials(response.data);
        } catch (error) {
            console.error('Error fetching testimonials:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setServerError(null);
        
        const formDataToSend = new FormData();
        
        // Append all form data
        formDataToSend.append('name', formData.name);
        formDataToSend.append('role', formData.role || '');
        formDataToSend.append('content', formData.content);
        formDataToSend.append('rating', parseInt(formData.rating) || 5);
        formDataToSend.append('is_active', formData.is_active ? 1 : 0);
        
        if (avatarFile) {
            formDataToSend.append('avatar', avatarFile);
        }

        try {
            const token = localStorage.getItem('admin_token');
            
            if (editing) {
                // ✅ FIX: Use POST with _method=PUT for FormData
                formDataToSend.append('_method', 'PUT');
                const response = await axios.post(
                    `http://localhost:8000/api/admin/testimonials/${editing.id}`,
                    formDataToSend,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                );
                console.log('Update success:', response.data);
            } else {
                // For create - use POST
                const response = await axios.post(
                    'http://localhost:8000/api/admin/testimonials',
                    formDataToSend,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                );
                console.log('Create success:', response.data);
            }
            
            fetchTestimonials();
            resetForm();
        } catch (error) {
            console.error('=== FULL ERROR DETAILS ===');
            console.error('Error object:', error);
            
            if (error.response) {
                console.error('Response status:', error.response.status);
                console.error('Response data:', error.response.data);
                
                if (error.response.status === 422) {
                    const validationErrors = error.response.data.errors || {};
                    setErrors(validationErrors);
                    
                    const errorMessages = Object.values(validationErrors).flat();
                    if (errorMessages.length > 0) {
                        setServerError('Validation Error: ' + errorMessages.join(', '));
                    } else {
                        setServerError('Please check your input and try again.');
                    }
                } else if (error.response.status === 500) {
                    let errorMessage = 'Internal server error occurred';
                    if (error.response.data && typeof error.response.data === 'object') {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                        if (error.response.data.error) {
                            errorMessage = error.response.data.error;
                        }
                    }
                    setServerError(errorMessage);
                }
            } else if (error.request) {
                setServerError('No response from server. Please check if the server is running.');
            } else {
                setServerError(error.message);
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this testimonial?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`http://localhost:8000/api/admin/testimonials/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchTestimonials();
            } catch (error) {
                console.error('Error deleting testimonial:', error);
            }
        }
    };

    const handleEdit = (testimonial) => {
        console.log('Editing testimonial:', testimonial);
        setEditing(testimonial);
        setFormData({
            name: testimonial.name || '',
            role: testimonial.role || '',
            content: testimonial.content || '',
            rating: testimonial.rating || 5,
            is_active: testimonial.is_active === 1 || testimonial.is_active === true,
        });
        setAvatarPreview(testimonial.avatar_path || null);
        setShowModal(true);
        setErrors({});
        setServerError(null);
    };

    const resetForm = () => {
        setFormData({
            name: '',
            role: '',
            content: '',
            rating: 5,
            is_active: true,
        });
        setAvatarFile(null);
        setAvatarPreview(null);
        setEditing(null);
        setShowModal(false);
        setErrors({});
        setServerError(null);
    };

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatarFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setAvatarPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    if (loading) return <div className="admin-loading">Loading testimonials...</div>;

    return (
        <div>
            <div className="admin-header">
                <h2>Testimonials Management</h2>
                <button className="admin-add-btn" onClick={() => setShowModal(true)}>
                    + Add New Testimonial
                </button>
            </div>

            {testimonials.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', color: '#6b7a8f' }}>
                    <p>No testimonials found. Click "Add New Testimonial" to create one.</p>
                </div>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Rating</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {testimonials.map((testimonial) => (
                                <tr key={testimonial.id}>
                                    <td><strong>{testimonial.name}</strong></td>
                                    <td>{testimonial.role || '-'}</td>
                                    <td>{'⭐'.repeat(testimonial.rating)}</td>
                                    <td>
                                        <span className={`admin-status-badge ${testimonial.is_active ? 'admin-status-active' : 'admin-status-inactive'}`}>
                                            {testimonial.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="admin-actions">
                                            <button className="admin-edit-btn" onClick={() => handleEdit(testimonial)}>Edit</button>
                                            <button className="admin-delete-btn" onClick={() => handleDelete(testimonial.id)}>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="admin-modal-overlay" onClick={() => resetForm()}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="admin-modal-header">
                            <h2>{editing ? 'Edit Testimonial' : 'Add New Testimonial'}</h2>
                            <button className="admin-modal-close" onClick={resetForm}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            {serverError && (
                                <div className="admin-server-error" style={{ 
                                    backgroundColor: '#f8d7da', 
                                    color: '#721c24', 
                                    padding: '0.75rem', 
                                    borderRadius: '0.375rem',
                                    marginBottom: '1rem',
                                    border: '1px solid #f5c6cb',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    <strong>Error:</strong> {serverError}
                                </div>
                            )}
                            <div className="admin-form-group">
                                <label>Name *</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                    required
                                />
                                {errors.name && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.name[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Role</label>
                                <input
                                    type="text"
                                    value={formData.role}
                                    onChange={(e) => setFormData({...formData, role: e.target.value})}
                                />
                                {errors.role && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.role[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Content *</label>
                                <textarea
                                    value={formData.content}
                                    onChange={(e) => setFormData({...formData, content: e.target.value})}
                                    rows="4"
                                    required
                                />
                                {errors.content && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.content[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Rating (1-5)</label>
                                <input
                                    type="number"
                                    min="1"
                                    max="5"
                                    value={formData.rating}
                                    onChange={(e) => setFormData({...formData, rating: parseInt(e.target.value) || 5})}
                                />
                                {errors.rating && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.rating[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Avatar</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleAvatarChange}
                                />
                                {errors.avatar && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.avatar[0]}
                                </div>}
                                {avatarPreview && (
                                    <div style={{ marginTop: '10px' }}>
                                        <img 
                                            src={avatarPreview} 
                                            alt="Preview" 
                                            className="admin-image-preview"
                                            style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="admin-form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_active}
                                        onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    />
                                    Active
                                </label>
                            </div>
                            <button type="submit" className="admin-submit-btn">
                                {editing ? 'Update Testimonial' : 'Create Testimonial'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Testimonials;